import React from 'react';
import { Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';

const CallVolumeChart = ({ data, loading }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover p-3 md:p-4 rounded-lg shadow-elevation-3 border border-border">
          <p className="text-xs md:text-sm font-medium text-popover-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-3 md:gap-4 mb-1">
              <span className="text-xs md:text-sm text-muted-foreground">{entry?.name}:</span>
              <span className="text-xs md:text-sm font-semibold" style={{ color: entry?.color }}>
                {entry?.name === 'Taux de conversion' ? `${entry?.value}%` : entry?.value}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="w-full h-64 md:h-80 lg:h-96 bg-muted animate-pulse rounded-lg"></div>
    );
  }

  return (
    <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Graphique de volume d'appels et taux de conversion">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis 
            dataKey="day" 
            stroke="var(--color-text-secondary)"
            style={{ fontSize: '12px' }}
            tick={{ fill: 'var(--color-text-secondary)' }}
          />
          <YAxis 
            yAxisId="left"
            stroke="var(--color-text-secondary)"
            style={{ fontSize: '12px' }}
            tick={{ fill: 'var(--color-text-secondary)' }}
          />
          <YAxis 
            yAxisId="right"
            orientation="right"
            stroke="var(--color-text-secondary)"
            style={{ fontSize: '12px' }}
            tick={{ fill: 'var(--color-text-secondary)' }}
            domain={[0, 100]}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }}
            iconType="circle"
          />
          <Bar 
            yAxisId="left"
            dataKey="calls" 
            fill="var(--color-primary)" 
            name="Appels"
            radius={[4, 4, 0, 0]}
          />
          <Line 
            yAxisId="right"
            type="monotone" 
            dataKey="conversionRate" 
            stroke="var(--color-accent)" 
            strokeWidth={2}
            name="Taux de conversion"
            dot={{ fill: 'var(--color-accent)', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CallVolumeChart;